import api from "@/services/api";

import { ADD_PAGE } from "@/store/mutation-types";

export default {
  async fetch({ commit, state }, params = {}) {
    const { name } = params;

    if (name in state.pages) {
      return state.pages[name];
    }

    const { payload = {} } = await api.pages.fetch(name);
    const { page } = payload;

    commit(ADD_PAGE, { page, name });

    return page;
  }
};
